import { useState } from "react";
import { postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";
import toast from "react-hot-toast";

export const useForgotPassword = (navigate) => {
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const response = await postApi(apiEndPoints.forgotPassword, data);
      if (response?.data?.status === 0) {
        toast.error(response?.data?.message);
      } else if (response?.data?.status === 1) {
        toast.success(response?.data?.message);
        navigate("/forgotpasswordsent", {
          state: response.data.message,
        });
      } else {
        toast.error("Something Went Wrong");
      }
    } catch (error) {
      toast.error(`Request failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return {
    onSubmit,
    loading,
  };
};